module.exports = __webpack_public_path__ + "static/media/easy-dividend-bg.6f7059f2.png";